/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Approve_ButtonInputs */

const en_admin_registration_approve_button = /** @type {(inputs: Admin_Registration_Approve_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

const de_admin_registration_approve_button = /** @type {(inputs: Admin_Registration_Approve_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zulassen`)
};

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Admin_Registration_Approve_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_approve_button = /** @type {((inputs?: Admin_Registration_Approve_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Approve_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_approve_button(inputs)
	return en_admin_registration_approve_button(inputs)
});